var vectorLayer;
var map;
var imagepath = '//olang-canada.myshopify.com/cdn/shop/t/3/assets/olang_marker_small.png?v=34220251710525183391685456118';
$(document).ready(function() {
let userLat = '';
let userLon = '';
if ("geolocation" in navigator) {
    navigator.geolocation.getCurrentPosition(function(position) {
        userLat = position.coords.latitude;
        userLon = position.coords.longitude;
      $('.userLocal').attr('data-userlat', userLat);
      $('.userLocal').attr('data-userlon', userLon);
    });
}
    /************************************************** Initiate Map ***************************************************/
    const key = 'koqJiH0buNoagcjlNLwD';
    const source = new ol.source.TileJSON({
        url: `https://api.maptiler.com/maps/streets-v2/tiles.json?key=${key}`,
        tileSize: 512,
        crossOrigin: 'anonymous'
    });

    map = new ol.Map({
        layers: [
            new ol.layer.Tile({
                source: source
            })
        ],
        target: 'map',
        view: new ol.View({
            constrainResolution: true,
            center: ol.proj.fromLonLat([-73.561668, 45.508888]), //[-73.561668,45.508888]
            zoom: 12
        })
    });

    // Create markers from locations
    vectorLayer = new ol.layer.Vector({
        source: new ol.source.Vector(),
        style: new ol.style.Style({
            image: new ol.style.Icon({
                anchor: [0.5, 1],
                src: "//olangcanada.com/cdn/shop/t/17/assets/olang_marker_small.png?v=34220251710525183391778680043"
            })
        })
    });

    map.addLayer(vectorLayer);

    /************************************************** set center to user location ***************************************************/
    if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(function(position) {
            var userLat = position.coords.latitude;
            var userLon = position.coords.longitude;
            console.log("Long: " + userLon + " Lat: " + userLat);
            map.getView().setCenter(ol.proj.transform([userLon, userLat], 'EPSG:4326', 'EPSG:3857'));
            map.getView().setZoom(12);
        });
    }

   // require([
   //   "esri/config",
   //    "esri/Map",
   //    "esri/views/MapView"
   //  ], function (esriConfig,Map, MapView) {

   //  esriConfig.apiKey = "AAPKe3c9c04462e14ce5a91bb3af0905409a9gJJ_4gR5o8vRER8vdeLEKmbCdRa8lIzK45LlU-oVsqmn285ALwXUUXRqishsxH-";
    const apiKey = "AAPKe3c9c04462e14ce5a91bb3af0905409a9gJJ_4gR5o8vRER8vdeLEKmbCdRa8lIzK45LlU-oVsqmn285ALwXUUXRqishsxH-";
    const basemapId = "ArcGIS:Navigation";
    const authentication = arcgisRest.ApiKeyManager.fromKey(apiKey);
    const center = ol.proj.transform(map.getView().getCenter(), "EPSG:3857", "EPSG:4326");
    var pointarea = '';
    //const locationlength = Object.keys(locations).length
    var i = 0;
    // debugger
     setTimeout(() => {
        if (userLon != '' && userLat !== '') {
            const usercords = [userLon, userLat]
            //const usercords = [-79.819463239899,43.326592488832]
            const point = turf.point(usercords);
            pointarea = turf.buffer(point, 10, {
                units: 'kilometers'
            });
            const feature = new ol.Feature({
                geometry: new ol.geom.Polygon(pointarea.geometry.coordinates)
            })
            map.getView().fit(feature.getGeometry().transform('EPSG:4326', 'EPSG:3857').getExtent());
        }
     }, 2000)
    loadmapdata(locations);

    //This function takes in latitude and longitude of two location and returns the distance between them as the crow flies (in km)
    function calcCrow(lat1, lon1, lat2, lon2) {
        var R = 6371; // km
        var dLat = toRad(lat2 - lat1);
        var dLon = toRad(lon2 - lon1);
        var lat1 = toRad(lat1);
        var lat2 = toRad(lat2);

        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var d = R * c;
        return d;
    }

    // Converts numeric degrees to radians
    function toRad(Value) {
        return Value * Math.PI / 180;
    }


/************************************************** if product is available ***************************************************/
    // $("#product option").each(function(){
    //  $.get("https://olangcanada.com/pages/confirmation?view=metaobject-json", (data, status) => {
    //     const newdata = $.parseJSON(data);
    //     newdata.shop.forEach(val => {
    //         if ($.inArray(this.value, val.offlineprod) >= 0) {
    //            $(this).addClass('visible');
    //         }
    //     });
    //   });
    // });


/************************************************** from product page ***************************************************/
    // $.urlParam = function(name) {
    //     var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    //     if (results == null) {
    //         return null;
    //     }
    //     return decodeURI(results[1]) || 0;
    // }

    // var param = $.urlParam('product');
    // $("#product option[value=" + param + "]").attr('selected', 'selected');
    // var selected = $('#product').val();
    // if (selected == param) {
    //     $.get("https://olang-canada.myshopify.com/pages/confirmation?view=metaobject-json", (data, status) => {
    //         const newdata = $.parseJSON(data);
    //         const newlocations = [];
    //         var newdatalist = "";
    //         newdata.shop.forEach(val => {
    //             if ($.inArray(selected, val.offlineprod) >= 0) {
    //                 newlocations.push(val);
    //                 var url = val.handle;
    //                 var adresse = val.adresse;
    //                 var coordslat = val.latitude;
    //                 var coordslon = val.longitude;
    //                if ($("#geocode-input").val() === "") {
    //                     var userLat = $('.userLocal').attr('data-userlat');
    //                     var userLon = $('.userLocal').attr('data-userlon');
    //                    var distance = calcCrow(userLat, userLon, coordslat, coordslon).toFixed(0);
    //                 newdatalist += "<div class='location_item' data-adresse='" + val.adresse + "' data-lat='" + val.latitude + "'  data-lon='" + val.longitude + "' data-distance='" + distance + "'> <a href='/pages/detaillant/" + url + "' target='_blank'>" +
    //                     "<img src='" + imagepath + "' height='50px' width='50px'><div class='location_details'><strong>" + val.title + "</strong>" +
    //                     "<p>" + val.adresse + "</p><p>" + val.telephone + "</p></div></a> </div>";
    //                 $("#sidebarlistview").html(newdatalist)
    //                   var $wrap = $('.location_holder');
    //                 $wrap.find('.location_item').sort(function(a, b) {
    //                         return +a.getAttribute('data-distance') -
    //                             +b.getAttribute('data-distance');
    //                     })
    //                     .appendTo($wrap);
    //             }
    //             }
    //         });

    //         loadmapdata(newlocations)
            
    //     });
    // }
    /************************************************** get product select results ***************************************************/
// $("#product").on("change", function() {
//     $.get("https://olangcanada.com/pages/confirmation?view=metaobject-json", (data, status) => {
//         const newdata = $.parseJSON(data);
//         const newlocations = []
//         var newdatalist = "";
//         var userLat;
//         var userLon;
//         newdata.shop.forEach(val => {
//             if ($.inArray(this.value, val.offlineprod) >= 0) {
//                 newlocations.push(val)
//                 var url = val.handle;
//                 var adresse = val.adresse;
//                 var coordslat = val.latitude;
//                 var coordslon = val.longitude;
//                 if ("geolocation" in navigator) {

//                     if ($("#geocode-input").val() === "") {
//                         var userLat = $('.userLocal').attr('data-userlat');
//                         var userLon = $('.userLocal').attr('data-userlon');
//                        var distance = calcCrow(userLat, userLon, coordslat, coordslon).toFixed(0);
//                     newdatalist += "<div class='location_item' data-distance='" + distance + "' data-adresse='" + val.adresse + "' data-lon='" + val.longitude + "' data-lat='" + val.latitude + "'> <a href='/pages/detaillant/" + url + "' target='_blank'>" +
//                         "<img src='" + imagepath + "' height='50px' width='50px'><div class='location_details'><strong>" + val.title + "</strong>" +
//                         "<p>" + val.adresse + "</p><p>" + val.telephone + "</p></div></a> </div>";
//                     $("#sidebarlistview").html(newdatalist);
//                     var $wrap = $('.location_holder');
//                     $wrap.find('.location_item').sort(function(a, b) {
//                             return +a.getAttribute('data-distance') -
//                                 +b.getAttribute('data-distance');
//                         })
//                         .appendTo($wrap);
//                     } else {
//                         const query = document.getElementById("geocode-input").value;
//                         arcgisRest
//                             .geocode({
//                                 singleLine: query,
//                                 authentication,

//                                 params: {
//                                     outFields: "*",
//                                     location: center.join(","),
//                                     //outSR: 3857 // Request coordinates in Web Mercator to simplify displaying
//                                 }
//                             })
//                             .then((response) => {
//                                 const user = response.candidates[0];
//                                 if (!user === 0) {
//                                     alert("That query didn't match any geocoding results.");
//                                     return;
//                                 }

//                                 userLat = user.location.y;
//                                 userLon = user.location.x;
//                                var distance = calcCrow(userLat, userLon, coordslat, coordslon).toFixed(0);
//                     newdatalist += "<div class='location_item' data-distance='" + distance + "' data-adresse='" + val.adresse + "' data-lon='" + val.longitude + "' data-lat='" + val.latitude + "'> <a href='/pages/detaillant/" + url + "' target='_blank'>" +
//                         "<img src='" + imagepath + "' height='50px' width='50px'><div class='location_details'><strong>" + val.title + "</strong>" +
//                         "<p>" + val.adresse + "</p><p>" + val.telephone + "</p></div></a> </div>";
//                     $("#sidebarlistview").html(newdatalist);
//                     var $wrap = $('.location_holder');
//                     $wrap.find('.location_item').sort(function(a, b) {
//                             return +a.getAttribute('data-distance') -
//                                 +b.getAttribute('data-distance');
//                         })
//                         .appendTo($wrap);
//                             });
//                     }
//                 } else {
//                     newdatalist += "<div class='location_item' data-adresse='" + val.adresse + "' data-lon='" + val.longitude + "' data-lat='" + val.latitude + "'> <a href='/pages/detaillant/" + url + "' target='_blank'>" +
//                         "<img src='" + imagepath + "' height='50px' width='50px'><div class='location_details'><strong>" + val.title + "</strong>" +
//                         "<p>" + val.adresse + "</p><p>" + val.telephone + "</p></div></a> </div>";
//                     $("#sidebarlistview").html(newdatalist);
//                 }
//             }
//             loadmapdata(newlocations);
//         });

//     });
//     $("#collection option").prop("selected", function() {
//         return this.defaultSelected;
//     });
//     map.getView().setZoom(11);
// });
    /************************************************** get collection select results ***************************************************/
$("#collection").on("change", function() {
    $.get("https://olangcanada.com/pages/confirmation?view=metaobject-json", (data, status) => {
        const newdata = $.parseJSON(data);
        const newlocations = []
        var newdatalist = "";
        var userLat;
        var userLon;
        newdata.shop.forEach(val => {
            if ($.inArray(this.value, val.collection) >= 0) {
                newlocations.push(val)
                var url = val.handle;
                var adresse = val.adresse;
                var coordslat = val.latitude;
                var coordslon = val.longitude;
                if ("geolocation" in navigator) {

                    if ($("#geocode-input").val() === "") {
                        var userLat = $('.userLocal').attr('data-userlat');
                        var userLon = $('.userLocal').attr('data-userlon');
                        var distance = calcCrow(userLat, userLon, coordslat, coordslon).toFixed(0);
                    newdatalist += "<div class='location_item' data-distance='" + distance + "' data-adresse='" + val.adresse + "' data-lon='" + val.longitude + "' data-lat='" + val.latitude + "'> <a href='/pages/detaillant/" + url + "' target='_blank'>" +
                        "<img src='" + imagepath + "' height='50px' width='50px'><div class='location_details'><strong>" + val.title + "</strong>" +
                        "<p>" + val.adresse + "</p><p>" + val.telephone + "</p></div></a> </div>";
                    $("#sidebarlistview").html(newdatalist);
                    var $wrap = $('.location_holder');
                    $wrap.find('.location_item').sort(function(a, b) {
                            return +a.getAttribute('data-distance') -
                                +b.getAttribute('data-distance');
                        })
                        .appendTo($wrap);
                    } else {
                      const query = document.getElementById("geocode-input").value;
                      console.log(query);
                        arcgisRest
                            .geocode({
                                singleLine: query,
                                authentication,

                                params: {
                                    outFields: "*",
                                    location: center.join(","),
                                    //outSR: 3857 // Request coordinates in Web Mercator to simplify displaying
                                }
                            })
                            .then((response) => {
                                const user = response.candidates[0];
                                if (!user === 0) {
                                    alert("That query didn't match any geocoding results.");
                                    return;
                                }

                                userLat = user.location.y;
                                userLon = user.location.x;
                                var distance = calcCrow(userLat, userLon, coordslat, coordslon).toFixed(0);
                    newdatalist += "<div class='location_item' data-distance='" + distance + "' data-adresse='" + val.adresse + "' data-lon='" + val.longitude + "' data-lat='" + val.latitude + "'> <a href='/pages/detaillant/" + url + "' target='_blank'>" +
                        "<img src='" + imagepath + "' height='50px' width='50px'><div class='location_details'><strong>" + val.title + "</strong>" +
                        "<p>" + val.adresse + "</p><p>" + val.telephone + "</p></div></a> </div>";
                    $("#sidebarlistview").html(newdatalist);
                    var $wrap = $('.location_holder');
                    $wrap.find('.location_item').sort(function(a, b) {
                            return +a.getAttribute('data-distance') -
                                +b.getAttribute('data-distance');
                        })
                        .appendTo($wrap);
                            });
                      
                    }
                } else {
                    newdatalist += "<div class='location_item' data-adresse='" + val.adresse + "' data-lon='" + val.longitude + "' data-lat='" + val.latitude + "'> <a href='/pages/detaillant/" + url + "' target='_blank'>" +
                        "<img src='" + imagepath + "' height='50px' width='50px'><div class='location_details'><strong>" + val.title + "</strong>" +
                        "<p>" + val.adresse + "</p><p>" + val.telephone + "</p></div></a> </div>";
                    $("#sidebarlistview").html(newdatalist);
                }
            }
            loadmapdata(newlocations);
        });

    });
    $("#product option").prop("selected", function() {
        //return this.defaultSelected;
       $("#product option[disabled]").attr('selected', 'selected');
    });
    map.getView().setZoom(11);
});
    /************************************************** Search by postal code ***************************************************/
    /* On enter submit */
    var input = document.getElementById("geocode-input");
    input.addEventListener("keypress", function(event) {
        if (event.key === "Enter") {
            event.preventDefault();
            document.getElementById("geocode-button").click();
        }
    });
    $("#geocode-button").click(function() {
      const query = document.getElementById("geocode-input").value;
      const authentication = arcgisRest.ApiKeyManager.fromKey(apiKey);
            /* get location */
            arcgisRest
                .geocode({
                    singleLine: query,
                    authentication,

                    params: {
                        outFields: "*",
                        location: center.join(","),
                        outSR: 3857 // Request coordinates in Web Mercator to simplify displaying
                    }
                })
                .then((response) => {
                    const user = response.candidates[0];
                    if (!user === 0) {
                        alert("That query didn't match any geocoding results.");
                        return;
                    }

                    const coords = [user.location.x, user.location.y];
                    map.getView().setCenter(coords);
                    map.getView().setZoom(12);
                });
        if ($("#collection").val() === "") { //$("#product").val() === "" && 
            const query = document.getElementById("geocode-input").value;
            const authentication = arcgisRest.ApiKeyManager.fromKey(apiKey);
            /* add new list on right */
            $.get("https://olangcanada.com/pages/confirmation?view=metaobject-json", (data, status) => {
                const newdata = $.parseJSON(data);
                const newlocations = [];
                var newdatalist = "";
                newdata.shop.forEach(val => {
                    newlocations.push(val)
                    var url = val.handle;
                    var adresse = val.adresse;
                    var coordslat = val.latitude;
                    var coordslon = val.longitude;
                    const query = document.getElementById("geocode-input").value;
                    const authentication = arcgisRest.ApiKeyManager.fromKey(apiKey);
                    /* get new user location */
                    arcgisRest
                        .geocode({
                            singleLine: query,
                            authentication,

                            params: {
                                outFields: "*",
                                location: center.join(","),
                                //outSR: 3857 // Request coordinates in Web Mercator to simplify displaying
                            }
                        })
                        .then((response) => {
                            const user = response.candidates[0];
                            if (!user === 0) {
                                alert("That query didn't match any geocoding results.");
                                return;
                            }

                            currentLat = user.location.y;
                            currentLng = user.location.x;
                            distance = calcCrow(currentLat, currentLng, coordslat, coordslon).toFixed(0);
                            newdatalist += "<div class='location_item' data-distance='" + distance + "' data-adresse='" + val.adresse + "' data-lat='" + val.latitude + "'  data-lon='" + val.longitude + "'> <a href='/pages/detaillant/" + url + "' target='_blank'>" +
                                "<img src='" + imagepath + "' height='50px' width='50px'><div class='location_details'><strong>" + val.title + "</strong>" +
                                "<p>" + val.adresse + "</p><p>" + val.telephone + "</p></div></a> </div>";
                            $("#sidebarlistview").html(newdatalist);
                            var $wrap = $('.location_holder');
                            $wrap.find('.location_item').sort(function(a, b) {
                                    return +a.getAttribute('data-distance') -
                                        +b.getAttribute('data-distance');
                                })
                                .appendTo($wrap);
                        });

                })
                loadmapdata(newlocations)

            });
        }
        // } else if ($("#product option:not([disabled])").is(':selected')) {
        //     $.get("https://olangcanada.com/pages/confirmation?view=metaobject-json", (data, status) => {
        //         const newdata = $.parseJSON(data);
        //         const newlocations = [];
        //         var newdatalist = "";
        //         var dropdownProd = $("#product").val();
        //       const query = document.getElementById("geocode-input").value;
        //     const authentication = arcgisRest.ApiKeyManager.fromKey(apiKey);
        //         newdata.shop.forEach(val => {
        //             if ($.inArray(dropdownProd, val.offlineprod) >= 0) {
        //                 newlocations.push(val)
        //                 var url = val.handle;
        //                 var adresse = val.adresse;
        //                 var coordslat = val.latitude;
        //                 var coordslon = val.longitude;
        //                 /* get new user location */
        //                 arcgisRest
        //                     .geocode({
        //                         singleLine: query,
        //                         authentication,

        //                         params: {
        //                             outFields: "*",
        //                             location: center.join(","),
        //                             //outSR: 3857 // Request coordinates in Web Mercator to simplify displaying
        //                         }
        //                     })
        //                     .then((response) => {
        //                         const user = response.candidates[0];
        //                         if (!user === 0) {
        //                             alert("That query didn't match any geocoding results.");
        //                             return;
        //                         }

        //                         currentLat = user.location.y;
        //                         currentLng = user.location.x;
        //                         distance = calcCrow(currentLat, currentLng, coordslat, coordslon).toFixed(0);
        //                         newdatalist += "<div class='location_item' data-distance='" + distance + "' data-adresse='" + val.adresse + "' data-lat='" + val.latitude + "'  data-lon='" + val.longitude + "'> <a href='/pages/detaillant/" + url + "' target='_blank'>" +
        //                             "<img src='" + imagepath + "' height='50px' width='50px'><div class='location_details'><strong>" + val.title + "</strong>" +
        //                             "<p>" + val.adresse + "</p><p>" + val.telephone + "</p></div></a> </div>";
        //                         $("#sidebarlistview").html(newdatalist);
        //                         var $wrap = $('.location_holder');
        //                         $wrap.find('.location_item').sort(function(a, b) {
        //                                 return +a.getAttribute('data-distance') -
        //                                     +b.getAttribute('data-distance');
        //                             })
        //                             .appendTo($wrap);
        //                     });

        //             }
        //         })
        //         loadmapdata(newlocations)

        //     });
        // } 
        else {
            console.log('selection collection');
            $.get("https://olangcanada.com/pages/confirmation?view=metaobject-json", (data, status) => {
                const newdata = $.parseJSON(data);
                const newlocations = [];
                var newdatalist = "";
                var dropdownCollection = $("#collection").val();
              const query = document.getElementById("geocode-input").value;
            const authentication = arcgisRest.ApiKeyManager.fromKey(apiKey);
                newdata.shop.forEach(val => {
                    if ($.inArray(dropdownCollection, val.collection) >= 0) {
                        newlocations.push(val)
                        var url = val.handle;
                        var adresse = val.adresse;
                        var coordslat = val.latitude;
                        var coordslon = val.longitude;
                        /* get new user location */
                        arcgisRest
                            .geocode({
                                singleLine: query,
                                authentication,

                                params: {
                                    outFields: "*",
                                    location: center.join(","),
                                    //outSR: 3857 // Request coordinates in Web Mercator to simplify displaying
                                }
                            })
                            .then((response) => {
                                const user = response.candidates[0];
                                if (!user === 0) {
                                    alert("That query didn't match any geocoding results.");
                                    return;
                                }

                                currentLat = user.location.y;
                                currentLng = user.location.x;
                                distance = calcCrow(currentLat, currentLng, coordslat, coordslon).toFixed(0);
                                newdatalist += "<div class='location_item' data-distance='" + distance + "' data-adresse='" + val.adresse + "' data-lat='" + val.latitude + "'  data-lon='" + val.longitude + "'> <a href='/pages/detaillant/" + url + "' target='_blank'>" +
                                    "<img src='" + imagepath + "' height='50px' width='50px'><div class='location_details'><strong>" + val.title + "</strong>" +
                                    "<p>" + val.adresse + "</p><p>" + val.telephone + "</p></div></a> </div>";
                                $("#sidebarlistview").html(newdatalist);
                                var $wrap = $('.location_holder');
                                $wrap.find('.location_item').sort(function(a, b) {
                                        return +a.getAttribute('data-distance') -
                                            +b.getAttribute('data-distance');
                                    })
                                    .appendTo($wrap);
                            });

                    }
                })
                loadmapdata(newlocations)

            });
        }
    });
 


    /************************************************** add map markers ***************************************************/
    function loadmapdata(locations) {
        vectorLayer.getSource().clear()
        $.each(locations, function(key, val) {
            i++;
            var adresse = val.adresse;
            var coordslat = val.latitude;
            var coordslon = val.longitude;
            var name = val.titre;
            var url = val.url;
                    const newFeat = new ol.Feature({
                        properties: val,
                        geometry: new ol.geom.Point(ol.proj.fromLonLat([parseFloat(coordslon), parseFloat(coordslat)]))
                    });

                    vectorLayer.getSource().addFeature(newFeat);
                
        });
    }
    /************************************************** popup window ***************************************************/
    var container = document.getElementById('popup');
    var content = document.getElementById('popup-content');
    var closer = document.getElementById('popup-closer');

    var overlay = new ol.Overlay({
        element: container,
        autoPan: true,
        autoPanAnimation: {
            duration: 250
        }
    });
    map.addOverlay(overlay);

    closer.onclick = function() {
        overlay.setPosition(undefined);
        closer.blur();
        return false;
    };

    map.on('singleclick', function(event) {
        //debugger
        var feature = map.forEachFeatureAtPixel(event.pixel, function(feature) {
            return feature;
        });
        if (map.hasFeatureAtPixel(event.pixel) === true) {
            var coordinate = event.coordinate;
            const properties = feature.getProperties();
            const propName = (properties.properties.titre) ? properties.properties.titre : properties.properties.title;
            const encoded = propName.toLowerCase().replace(/\W+(?!$)/g, '-').replace(/\s/g, "-").replace(/\+/g,'');
            content.innerHTML = '<a href="/pages/detaillant/' + encoded + '" target="_blank">' + propName + '</a>';
            // content.innerHTML = (properties.properties.titre)?properties.properties.titre:properties.properties.title;
            overlay.setPosition(coordinate);
        } else {
            overlay.setPosition(undefined);
            closer.blur();
        }
    });
    /************************************************** Check for the current user location ***************************************************/
    if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(function(position) {
            var userLat = position.coords.latitude;
            var userLon = position.coords.longitude;

            $('div.location_item').each(function() {
                var coordslat = $(this).attr('data-lat');
                var coordslon = $(this).attr('data-lon');
                var distance = calcCrow(userLat, userLon, coordslat, coordslon).toFixed(0);

                        if (distance > 10) {
                            $(this).remove();
                        } else {
                            $(this).attr('data-distance', distance);
                            // sort function
                            var $wrap = $('.location_holder');
                            $wrap.find('.location_item').sort(function(a, b) {
                                    return +a.getAttribute('data-distance') -
                                        +b.getAttribute('data-distance');
                                })
                                .appendTo($wrap);
                        }
                   
            });

        });
    }

    navigator.geolocation.watchPosition(function(position) {},
        function(error) {
            if (error.code == error.PERMISSION_DENIED)
                $('div.location_item').each(function() {
                    var coordslat = $(this).attr('data-lat');
                    var coordslon = $(this).attr('data-lon');
                    var mtlLat = 45.48960759037542;
                    var mtlLng = -73.59856310119923;
                    var distance = calcCrow(mtlLat, mtlLng, coordslat, coordslon).toFixed(0);
                            if (distance > 10) {
                                $(this).remove();
                            } else {
                                $(this).attr('data-distance', distance);
                                // sort function
                                var $wrap = $('.location_holder');
                                $wrap.find('.location_item').sort(function(a, b) {
                                        return +a.getAttribute('data-distance') -
                                            +b.getAttribute('data-distance');
                                    })
                                    .appendTo($wrap);
                            }
                        
                });
        });
});